import { createContext, useContext } from 'react';

interface ApiExplorerFeedbackContext {
  showFeedbackPrompt: boolean;
  incrementUserEndpointCount: (endpointId: string) => void;
  resetUserEndpointCount: (endpointId: string, lastResponse?: string) => void;
}

const ApiExplorerFeedbackContextInstance =
  createContext<ApiExplorerFeedbackContext>({
    showFeedbackPrompt: false,
    incrementUserEndpointCount: (_) => null,
    resetUserEndpointCount: (_) => null,
  });

const ApiExplorerFeedbackContextProvider =
  ApiExplorerFeedbackContextInstance.Provider;

const useApiExplorerFeedbackContext = () => {
  return useContext(ApiExplorerFeedbackContextInstance);
};

export {
  ApiExplorerFeedbackContextProvider,
  useApiExplorerFeedbackContext,
  type ApiExplorerFeedbackContext,
};
